export default __webpack_public_path__ + "static/media/Arrow Down.e8620f84.svg";